import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-[0_4px_14px_-4px_hsl(var(--primary)/0.45)] hover:bg-[hsl(152_28%_24%)] active:bg-[hsl(152_32%_17%)] active:shadow-[inset_0_2px_5px_hsl(28_20%_12%_/_0.18)]",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 active:bg-destructive/95",
        outline:
          "border border-[hsl(38_16%_78%)] bg-[hsl(43_32%_98%)] text-foreground shadow-sm hover:bg-[hsl(38_18%_92%)] hover:border-[hsl(38_16%_72%)] active:bg-[hsl(38_18%_88%)]",
        secondary:
          "border border-[hsl(38_16%_82%)] bg-secondary text-secondary-foreground shadow-sm hover:bg-[hsl(38_18%_86%)] active:bg-[hsl(38_18%_83%)]",
        ghost:
          "text-[hsl(32_10%_34%)] hover:bg-[hsl(38_18%_92%)] hover:text-foreground active:bg-[hsl(38_18%_88%)]",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size }), className)}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
